import { render } from "./SupplySection.vue?vue&type=template&id=8bcff4e0"
import script from "./SupplySection.vue?vue&type=script&lang=js"
export * from "./SupplySection.vue?vue&type=script&lang=js"

import "./SupplySection.vue?vue&type=style&index=0&id=8bcff4e0&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__